/** The shared Content page now owns its Translations tab directly. */
export function ContentLocalizationPortal({ path: _path }: { path: string }) { return null; }
